import React, { useEffect, useState } from 'react';
import Tab from '@material-ui/core/Tab';
import TabPanel from '@material-ui/lab/TabPanel';
import TabContext from '@material-ui/lab/TabContext';
import Tabs from '@material-ui/core/Tabs';
import AppBar from '@material-ui/core/AppBar';
import ImunologiaLaminasContainer from './content/imunologia.container';
import { useIntl } from 'react-intl';

function ImunologiaPage (props) {
  const intl = useIntl()

  const [currentTab, setCurrentTab] = useState('0');

  useEffect(() => {
    setTimeout(() => {
      setCurrentTab('1');
    }, 200);
  }, []);

  const mudarAba = (event, tab) => {
    setCurrentTab(tab);
  };

  return (
    <div className='mv-imunologia-page'>
      <TabContext value={currentTab}>
        <AppBar position='static' color='default'>
          <Tabs
            value={currentTab}
            onChange={mudarAba}
            variant='scrollable'
            //scrollButtons='on'
            indicatorColor='primary'
            textColor='primary'
            aria-label='scrollable force tabs example'
          >
            <Tab
              icon={<i className='tab-icons fas fa-eye-dropper'></i>}
              label={`${intl.formatMessage({id: 'dashboards.immunology.immunologySlides'})}`}
              value='1'
            />

            <Tab value='0' disabled></Tab>
          </Tabs>
        </AppBar>

        <TabPanel value='0'></TabPanel>
        <TabPanel value='1'>
          <ImunologiaLaminasContainer {...props} intl={intl}/>
        </TabPanel>
      </TabContext>
    </div>
  );
}

export default ImunologiaPage;



// WEBPACK FOOTER //
// ./src/pages/imunologia/imunologia.page.js